import React from "react";

export const PerformanceSunshine = () => {
  return (
    <div className="performance-factors">
      <div className="performance-factors-item no-margin">
        <span className="title">Hover @ GW @ 10 Deg C</span>
      </div>
      <div className="performance-factors-item no-margin">
        <span className="title">IGE:</span>
        &nbsp;
        <span className="title">8500 FT</span>
      </div>
      <div className="performance-factors-item no-margin">
        <span className="title">OGE:</span>
        &nbsp;
        <span className="title">7000 FT</span>
      </div>
      <div className="performance-factors-item no-margin">
        <span className="title">Top of HV @ GW 20 Deg C:</span>
      </div>
      <div className="performance-factors-item no-margin">
        <span className="title">  0 A/S</span>
      </div>
      <div className="performance-factors-item no-margin">
        <span className="title">2000 FT MSL 800 FT</span>
      </div>
    </div>
)}
